import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import img from '../../../assets/carousel-bg.png';
// import img1 from '../../../assets/carousel-bg1.png';
import img2 from "../../../assets/carousel-bg2.png";
import img3 from "../../../assets/carousel-bg3.png";
import { CustomNextArrow, CustomPrevArrow } from "./customArrows";
import { useEffect } from "react";
import { UserSideSlider } from "../../../service/service";
import { useState } from "react";

function Carousel() {
  const baseUrl = window.location.origin;
  const [slides, setSlides] = useState([
    {
      id: -1,
      image: img2,
      title: "Live Classes",
      description: `Watch Rabbi Paltiel’s live classes`,
      type: "class",
      buttonText: "Watch now",
      buttonUrl: `${baseUrl}/live`,
    },
    {
      id: -2,
      image: img3,
      title: "Ask a Question",
      description: `Ask anything and seek guidance`,
      type: "question",
      buttonText: "Ask",
      buttonUrl: `${baseUrl}/ask-question`,
    },
  ]);
  useEffect(() => {
    UserSideSlider()
      .then((result) => {
        const updatedData = result.data?.map((item) => ({
          id: item.id,
          image: item.url,
          title: item.title,
          // Quick fix for null string as value of description property
          description: item.description !== "null" ? item.description : "",
          type: "blog",
          buttonText: item.buttonText,
          buttonUrl: item.buttonUrl,
          key: item.id,
        }));
        setSlides([...updatedData, ...slides]);
      })
      .catch((error) => {
        console.log(error.message);
      });
  }, []);

  const settings = {
    dots: false,
    lazyLoad: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    initialSlide: 0,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };
  // const slides = [
  //   {
  //     id: 1,
  //     image: img,
  //     title:'Elu',
  //     description:'Series on the ”King in the Field”',
  //     type:'blog',
  //     buttonText:'Learn more',
  //     buttonUrl:'',
  //   },
  //   {
  //     id: 2,
  //     image: img1,
  //     title:'Pirkei Avos',
  //     description:`Complete Ma'amarim, Pirkei Avos.`,
  //     type:'blog',
  //     buttonText:'Learn more',
  //     buttonUrl:'',
  //   },
  //   {
  //     id: 3,
  //     image: img2,
  //     title:'Live Classes',
  //     description:`Watch Rabbi Paltiel’s live classes`,
  //     type:'class',
  //     buttonText:'Watch now',
  //     buttonUrl:'https://insidechassidus.org/live/',
  //   },
  //   {
  //     id: 4,
  //     image: img3,
  //     title:'Ask a Question',
  //     description:`Ask anything and seek guidance`,
  //     type:'question',
  //     buttonText:'Ask',
  //     buttonUrl:'',
  //   }
  // ]
  return (
    <section
      id="carousel-section"
      className="pt-4 sm:pt-[32px] px-2 xs:px-5 pb-4 sm:pb-6"
    >
      <div className="2xl:max-w-2xl xl:max-w-xl lg:max-w-lg md:max-w-md sm:max-w-sm mx-auto">
        <div className="min-h-[203px] h-[40vw]  lg:h-[469px] rounded-3xl md:rounded-[32px] overflow-hidden">
          <Slider {...settings}>
            {slides.map((obj, index) => (
              <div key={"item-" + index}>
                <div
                  className="min-h-[203px] h-[40vw]  lg:h-[469px] !bg-cover relative"
                  //  style={{ background: `url(${obj.image})` }}
                  style={{
                    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.28) 0%, rgba(0, 0, 0, 0.28) 100%), url(${obj.image}), lightgray 0px -6.534px / 100% 134.356% no-repeat`,
                  }}
                >
                  <div className="text-whiteGrey absolute bottom-0 pb-[12px] pl-[12px] md:pb-[45px] md:pl-[45px]">
                    <div className="text-2xl md:text-[38px] font-extrabold leading-[normal]">
                      {obj.title}
                    </div>
                    <div className="text-sm md:text-base font-semibold py-2 md:pt-3 md:pb-6 leading-[normal]">
                      {obj.description}
                    </div>
                    <div>
                      <a
                        href={obj.buttonUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex w-fit md:gap-x-4 h-10 lg:h-12 items-center justify-center rounded-3xl border-whiteGrey border-[1px] px-6 md:px-8 md:py-[14px] text-sm md:text-[18px] font-bold leading-7 text-whiteGrey shadow-sm "
                      >
                        {obj.buttonText}
                        <span aria-hidden="true" className="text-[13px]">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M17.92 11.62C17.8724 11.4973 17.801 11.3851 17.71 11.29L12.71 6.29C12.6168 6.19676 12.5061 6.1228 12.3842 6.07234C12.2624 6.02188 12.1319 5.99591 12 5.99591C11.7337 5.99591 11.4783 6.1017 11.29 6.29C11.1968 6.38324 11.1228 6.49393 11.0723 6.61575C11.0219 6.73758 10.9959 6.86814 10.9959 7C10.9959 7.2663 11.1017 7.5217 11.29 7.71L14.59 11H7C6.73478 11 6.48043 11.1054 6.29289 11.2929C6.10536 11.4804 6 11.7348 6 12C6 12.2652 6.10536 12.5196 6.29289 12.7071C6.48043 12.8946 6.73478 13 7 13H14.59L11.29 16.29C11.1963 16.383 11.1219 16.4936 11.0711 16.6154C11.0203 16.7373 10.9942 16.868 10.9942 17C10.9942 17.132 11.0203 17.2627 11.0711 17.3846C11.1219 17.5064 11.1963 17.617 11.29 17.71C11.383 17.8037 11.4936 17.8781 11.6154 17.9289C11.7373 17.9797 11.868 18.0058 12 18.0058C12.132 18.0058 12.2627 17.9797 12.3846 17.9289C12.5064 17.8781 12.617 17.8037 12.71 17.71L17.71 12.71C17.801 12.6149 17.8724 12.5028 17.92 12.38C18.02 12.1365 18.02 11.8635 17.92 11.62Z"
                              fill="#F4FBF7"
                            />
                          </svg>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}

export default Carousel;
